import React, {useContext, useEffect, useState} from 'react';
import {CssFramework} from './CssFramework';
import {DeclaredComponent} from './DynamicComponent';
import coreComponents from '../coreComponents';
import customerComponents from '../customerComponents';
import {consumePath, Navigation, NavigationContext} from '../navigation/Navigation';
import FormValidationProvider from '../context/FormValidationProvider';
import PremiumAlertMessageProvider from '../context/PremiumAlertMessageProvider';
import DriversAndVehiclesDataReportProvider from '../context/DriversAndVehiclesDataReportProvider';
import WorkflowStepsProvider from '../context/WorkflowStepsProvider';
import PaymentInfoProvider from '../context/PaymentInfoProvider';


import {EditorModeButton} from '../editor/EditorModeButton';
import {setLastResortErrorMessage} from './lastResortErrorMessage';
import {ErrorScope} from './ErrorScope';
import StepsValidationStatusProvider from '../context/StepsValidationStatusProvider';
import {env} from '../env';
import GlobalStateProvider from '../context/GlobalStateProvider';

export const ConfigContext = React.createContext({});
export const PortalContext = React.createContext({});
export const DynamicComponentsContext = React.createContext({});

export const PRODUCTION = env.production; // eslint-disable-line no-undef

export function PortalApp(props) {

  const {config: initialConfig, components} = props;
  const allComponents = {...coreComponents, ...customerComponents, ...components};

  const [config, setConfig] = useState(initialConfig);
  const [editMode, setEditMode] = useState(false);
  useEffect(()=> {
    window.presentationMetaData = config;
    window.setPresentationMetaData = setConfig;
  })

  useEffect(()=>{
    let script = document.createElement("script");
    script.type = "application/javascript";
    script.src = env.gwPaymentSDKURL;
    script.setAttribute('data-gw-payments-sdk', '');
    script.async = true;
    document.head.appendChild(script);
  }, [])

  useEffect(() =>  setLastResortErrorMessage(config.lastResortErrorMessage), [config.lastResortErrorMessage]);

  const portalContext = {
    refreshConfig: (oldChunk, newChunk) => updateChunk(oldChunk, newChunk, setConfig),
    editMode
  };

  return <ConfigContext.Provider value={config}>
    {!PRODUCTION && <EditorModeButton value={editMode} onChange={setEditMode}/> }
    {/*<LoginButton />*/}
    <Navigation>
      <GlobalStateProvider>
        <DynamicComponentsContext.Provider value={allComponents}>
          <PortalContext.Provider value={portalContext}>
            <FormValidationProvider>
              <PremiumAlertMessageProvider>
                  <WorkflowStepsProvider>
                  <DriversAndVehiclesDataReportProvider>
                    <StepsValidationStatusProvider>
                      <CssFramework>
                        <DeclaredComponent declaration={config.layout} >
                          <ErrorScope errorMessage={config.lastResortErrorMessage}>
                            <RootRoutes config={config} />
                          </ErrorScope>
                        </DeclaredComponent>
                      </CssFramework>
                    </StepsValidationStatusProvider>
                    </DriversAndVehiclesDataReportProvider>
                  </WorkflowStepsProvider>
              </PremiumAlertMessageProvider>
            </FormValidationProvider>
          </PortalContext.Provider>
        </DynamicComponentsContext.Provider>
      </GlobalStateProvider>
    </Navigation>
  </ConfigContext.Provider>;

}

function RootRoutes({config, children}) {
  const [navigation, [routeName]] = consumePath(useContext(NavigationContext), 1);
  let page = config.routes['/' + routeName];
  if (!page) {
    page = config.routes['/'];
  }
  return <NavigationContext.Provider value={navigation}>
    <DeclaredComponent declaration={page}>
      {children}
    </DeclaredComponent>
  </NavigationContext.Provider>;
}


function updateChunk(oldChunk, newChunk, setConfig) {

  setConfig(oldConfig => {

    function traverse(node) {

      if (Array.isArray(node)) {
        for (let i = 0; i < node.length; i++) {
          if (node[i] === oldChunk) {
            node[i] = newChunk;
            return;
          } else {
            traverse(node[i]);
          }
        }
      } else if (typeof node === 'object') {

        const keys = Object.keys(node);

        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          if (node[key] === oldChunk) {
            node[key] = newChunk;
            return;
          } else {
            traverse(node[key]);
          }
        }
      }
    }
    traverse(oldConfig);
    return JSON.parse(JSON.stringify(oldConfig));

  });


}